import AppConfig from 'qs-config/AppConfig';
import firebase from 'qs-config/FirebaseConfig';

const inFlight = new Set();
let cachedAuthToken = null;
let listenersAttached = false;

const refreshAuthToken = async () => {
  try {
    const user = firebase.auth().currentUser;
    if (!user) {
      return;
    }
    cachedAuthToken = await user.getIdToken(false);
  } catch (err) {
    // Best effort — the flush is also best effort
  }
};

const flushInFlightAsErrored = () => {
  if (inFlight.size === 0 || !cachedAuthToken) {
    return;
  }
  const pictureIds = Array.from(inFlight);
  inFlight.clear();
  try {
    fetch(`${AppConfig.qsApiEndPoint}/v1/product/errored`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: cachedAuthToken
      },
      body: JSON.stringify({ pictureIds }),
      keepalive: true
    });
  } catch (err) {
    // pagehide context — nothing recoverable here
  }
};

const attachUnloadListeners = () => {
  if (listenersAttached || typeof window === 'undefined') {
    return;
  }
  listenersAttached = true;
  window.addEventListener('pagehide', flushInFlightAsErrored);
  window.addEventListener('beforeunload', flushInFlightAsErrored);
};

export const registerInFlightUploads = pictureIds => {
  if (!Array.isArray(pictureIds) || !pictureIds.length) {
    return;
  }
  pictureIds.forEach(id => {
    if (id) {
      inFlight.add(id);
    }
  });
  attachUnloadListeners();
  refreshAuthToken();
};

export const clearInFlightUpload = pictureId => {
  if (pictureId) {
    inFlight.delete(pictureId);
  }
};

export const clearAllInFlightUploads = () => {
  inFlight.clear();
};
